import {
    Component,
    OnInit,
    AfterViewInit, OnDestroy,
    Output,
    EventEmitter,
    Input,
    ViewChild,
    Renderer2,
    ElementRef
} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {StocksService} from 'app/stocks/services/stocks.service';
import {CommonDataService} from 'app/services/common-data.service';
import {StocksFilterService} from "app/stocks/services/stocks-filter.service";
import * as Popper from 'popper.js/dist/umd/popper';
import {StocksHelper} from "../../models/stocks-helper";
import {AggregationSelector} from "../../models/aggregation-selector";

type InitialData = { accessDenied: boolean, rights: any };

@Component({
    selector: 'aggregation-list',
    templateUrl: './aggregations-list.component.html',
    styleUrls: ['./aggregations-list.component.css']
})
export class AggregationListComponent implements OnInit, AfterViewInit, OnDestroy{

    constructor(public readonly translateService: TranslateService,
                private readonly renderer: Renderer2,
                public readonly commonData: CommonDataService){
        this.helper = new StocksHelper();
        this.close = new EventEmitter<{command: string ,aggregation: AggregationSelector}>();
        this.show = false;
        this.aggregation = null;
        this.aggregators = [];

    }

    private initialise = (): void =>{

    };

    @Input() private inData: AggregationSelector;
    @Input() private popperWrapperId?: string;

    @Output()
    private readonly close: EventEmitter<{command: string ,aggregation: AggregationSelector}>;

    @ViewChild('mainWrapper')
    private mainWrapper: ElementRef;

    // @ViewChild('addPopper')
    // private addPopper: ElementRef;

    private helper: StocksHelper;
    private popperAddVar: Popper;
    public show: boolean;
    private addRef: any;

    private aggregation: AggregationSelector;
    private translates: any;
    private aggregators: string[];
    private listenMouseDown: () => void;

    async ngOnInit(){
        let result = await this.translateService.get(['Avg', 'Sum', 'Min', 'Max']).toPromise();

        this.translates = result;
        this.translates.avg = this.translates.Avg;
        this.translates.sum = this.translates.Sum;
        this.translates.min = this.translates.Min;
        this.translates.max = this.translates.Max;

        this.aggregation = this.helper.copyAggregatorSelector(this.inData);


        this.aggregators = ['sum', 'avg', 'min', 'max'];


    }

    ngOnDestroy(){
        this.listenMouseDown();

    }

    ngAfterViewInit(){
        this.addRef = $(`#${this.inData.id}`)[0];
        this.popperAdd();
        this.listenMouseDown = this.renderer.listen('body', 'mousedown', (e: MouseEvent) => this.hideList(e));
        // this.renderer.listen('body', 'contextmenu', (e: MouseEvent) => this.hideMenu(e));
        // this.renderer.listen('body', 'mousedown', (e: MouseEvent) => this.hideMenu(e));
        // this.popperAdd()
    }

    public select = (item: string, e?: MouseEvent): void => {
        if (e){
            e.stopPropagation()
        }

        this.aggregation.data[item] = !this.aggregation.data[item];
    };



    public popperAdd = (): void => {
        this.popperAddVar = new Popper(this.addRef, this.mainWrapper.nativeElement.parentElement, {
            placement: 'left',
            modifiers: {
                flip: {
                    behavior: ['left']
                },
                preventOverflow: {
                    boundariesElement: this.popperWrapperId ? $(this.popperWrapperId)[0] : document.body,
                },
            },
        });
    };


    //# emit close event
    public apply = (command: string): void => {
        switch (command){
            case 'Apply':
                this.close.emit({command: this.helper.hasSelectedAg(this.aggregation) ? 'add' : 'remove', aggregation: this.aggregation});
                break;
            case 'Cancel':
                this.close.emit({command: 'cancel', aggregation: null});
                break;
        }
        this.show = false;
    };

    //# hide list and apply changes
    private hideList = (e: MouseEvent): void => {
        if (this.helper.hideList(this.mainWrapper, e, this.renderer)) {
            this.apply('Apply');
        }
    }

}




// WEBPACK FOOTER //
// ./src/app/stocks/components/aggregations-list.component/aggregations-list.component.ts